import React, { Component } from 'react'
import {GridRow, GridCol, Heading, Link} from '@lmig/lmds-react'
import {RequestTypeCard} from './RequestType/RequestTypeCard'

class RequestTypeGrid extends Component {
  render() {
    return (
        <div style={{marginTop: '5px'}} className={'request-type-grid'}>
          <Heading type={'h3-light'}>Looking to Submit a Request?</Heading>
          <GridRow>
              <GridCol>
                  <RequestTypeCard
                      title='Request a Name or Tax ID Change'
                      formNumber='1'
                  />
                  <RequestTypeCard
                      title='Request an Address Change or 1099 Reprint'
                      formNumber='3'
                  />

             </GridCol>
             <GridCol>
                 <RequestTypeCard
                     title='Request Additional Information'
                     formNumber='2'
                 />
                 <RequestTypeCard
                     title='Request a 1099 (I Did Not Receive My 1099)'
                     formNumber='4'
                 />
              </GridCol>

          </GridRow>
            <div>
                <p> Already submitted a request? <Link href='/viewticket'>View ticket status</Link>.</p>
            </div>
        </div>
    )
  }
}

export default RequestTypeGrid
